import { lazy } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { Route, Routes } from "react-router";

const Home = lazy(() => import("@/pages/Home"));
const Agenda = lazy(() => import("@/pages/Agenda"));
const Resources = lazy(() => import("@/pages/Resources/Resources"));
const Events = lazy(() => import("@/pages/Events"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("@/pages/TermsOfService"));

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Header />
      <div className="flex-grow px-6 md:px-16">
        <Routes>
          <Route path="/" element={<Home />} />
          {/*<Route path="/events" element={<Events/>}/>*/}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/*" element={<Home />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
